/**
 * @deprecated
 * Retrieves Universal Analytics parameters from the first tracker found on the page.
 *
 * This function is deprecated because Universal Analytics is being phased out in favor of Google Analytics 4.
 *
 * @returns {Record<string, string>} - An object with key-value pairs parsed from the GA linker parameter.
 */
export const getUniversalParams = (): Record<string, string> => {
  //TODO: remove this function in PEX-2705
  return {};
};
